import { Card, CardContent, Stack, Typography } from "@mui/material";
import { FlexLoadingBlock, Page } from "@synota-io/synota-shared-ui";
import { useParams } from "react-router-dom";
import { useUserDetails } from "../../../api/hooks/useUserDetails";
import { UserReceiveConfiguration } from "../users/components/UserReceiveConfiguration";

export const UserSettingsPage = () => {
  const params = useParams<{ id: string }>();

  const { user, isPending } = useUserDetails({ id: params.id });

  if (isPending) {
    return <FlexLoadingBlock>Loading...</FlexLoadingBlock>;
  }

  if (!user) {
    return null;
  }

  return (
    <Page>
      <Stack gap={6}>
        <Typography variant="h5">{user?.public_name}</Typography>
        <Card>
          <CardContent>
            <UserReceiveConfiguration />
          </CardContent>
        </Card>
      </Stack>
    </Page>
  );
};
